import React from "react";
import { Flex, Button, Text, Box, Icon } from "@chakra-ui/react";
import { ChevronRightIcon } from "@chakra-ui/icons";

const getPageNumbers = (current, total) => {
  const arr = [];
  if (total <= 5) {
    for (let i = 1; i <= total; i++) arr.push(i);
  } else {
    if (current <= 3) {
      arr.push(1, 2, 3, 4, '...', total);
    } else if (current >= total - 2) {
      arr.push(1, '...', total - 3, total - 2, total - 1, total);
    } else {
      arr.push(1, '...', current - 1, current, current + 1, '...', total);
    }
  }
  return arr;
};

const SkillCoursePagination = ({
  currentPage,
  totalPages,
  pageSize,
  totalItems,
  onPageChange,
  showingStart,
  showingEnd
}) => {
  const pageNumbers = getPageNumbers(currentPage, totalPages);
  return (
    <Flex justify="space-between" align="center" mt={2} mb={10} w="100%">
      {/* Pagination Numbers */}
      <Flex align="center" gap={2}>
        {pageNumbers.map((num, idx) =>
          num === '...' ? (
            <Text key={idx} color="gray.500" fontWeight="bold" px={1}>...</Text>
          ) : (
            <Button
              key={num}
              onClick={() => onPageChange(num)}
              size="sm"
              borderRadius="full"
              bg={currentPage === num ? '#38876A' : 'white'}
              color={currentPage === num ? 'white' : '#38876A'}
              fontWeight={currentPage === num ? 'bold' : 'normal'}
              _hover={{ bg: '#38876A', color: 'white' }}
              minW={7}
            >
              {num}
            </Button>
          )
        )}
        <Button
          onClick={() => onPageChange(totalPages)}
          size="sm"
          borderRadius="full"
          bg="white"
          color="#38876A"
          fontWeight="normal"
          _hover={{ bg: '#38876A', color: 'white' }}
          minW={7}
        >
          Last <Icon as={ChevronRightIcon} ml={1} />
        </Button>
      </Flex>
      {/* Showing Info */}
      <Text color="gray.600" fontSize="md">
        Showing <b>{showingStart}</b> to <b>{showingEnd}</b> of <b>{totalItems.toLocaleString()}</b>
      </Text>
    </Flex>
  );
};

export default SkillCoursePagination; 